import {
    AzureLayer,
} from "@esWebAPI/es/map/layer/azure/AzureLayer";
import atlas, {Map, HeatMapLayerOptions, layer, source} from "azure-maps-control";
import {ILayerView, LayerInfo} from "@esWebAPI/es/model/Layer";
import {HeatMapThematicStyler} from "@esWebAPI/es/map/styler/HeatMapThematicStyler";
import {DatasourceManager} from "@esWebAPI/es/map/module/DatasourceManager";

export class AzureHeatMapLayer implements AzureLayer {

    private readonly _map: Map;
    private readonly datasourceManager: DatasourceManager;

    private _layerView: ILayerView;
    private _layerInfo: LayerInfo;

    private _layer: layer.HeatMapLayer|undefined;
    private datasourceId: string|undefined;


    constructor(map: Map, layerView: ILayerView, layerInfo: LayerInfo, datasourceManager: DatasourceManager) {
        this._map = map;
        this._layerView = layerView;
        this._layerInfo = layerInfo;
        this.datasourceManager = datasourceManager;
    }

    private getOptions() {
        const heatMapThematic = this._layerView.styleSettings.heatMapSettings;
        const heatMapThematicStyler = new HeatMapThematicStyler(heatMapThematic);

        const options  = {
            color: heatMapThematicStyler.getColorExpression(heatMapThematic?.palette),
            radius: heatMapThematic.radius,
            opacity: 1,
            weight: 1,
            intensity: heatMapThematic.intensity,
            visible: this._layerView.enabled && heatMapThematic?.enabled,
            filter: ["==", ['geometry-type'], "Point"],
            sourceLayer: this.datasourceId && this.datasourceManager.isPbf(this.datasourceId) ? 'es' : undefined
        } as HeatMapLayerOptions;

        const attr = heatMapThematic.attr;
        if (!attr) {
            return options;
        }

        const attrRange = this._layerInfo.featureInfo.attributeRanges[attr];
        if (!attrRange) {
            es.log.error("Heatmap attribute not present in attribute ranges... Defaulting to point density", attr);
            return options;
        }

        options.weight = [
            "interpolate", ["linear"],
            ["get", heatMapThematic.attr],
            +attrRange.min, 0.01,
            +(attrRange.min === attrRange.max ? attrRange.max + 0.0001 : attrRange.max), 2.5,
        ];

        return options;
    }

    public create(datasource: atlas.source.Source): Promise<void> {
        this.datasourceId = datasource.getId();
        this._layer = new layer.HeatMapLayer(datasource.getId(), this.getLayerId(), this.getOptions());
        this._map.layers.add(this._layer);
        return Promise.resolve();
    }

    public async recreate(layerView: ILayerView, layerInfo: LayerInfo, datasource: source.Source) {
        this._layerView = layerView;
        this._layerInfo = layerInfo;
        this.datasourceId = datasource.getId();
        return this.create(datasource);
    }

    public getLayerId(): string {
        return "hm_" + this._layerView.id;
    }

    public hide(): void {
        this._layer?.setOptions({visible: false});
    }

    public hideFeature(_featureId: number): void {
    }

    public remove(): void {
        if (this._layer && this._map.layers.getLayerById(this._layer.getId())) {
            this._map.layers.remove(this._layer.getId());
        }
        this._layer = undefined;
    }

    public showFeatures(): void {
    }

    public update(layerView: ILayerView, layerInfo: LayerInfo): Promise<void> {
        this._layerView = layerView;
        this._layerInfo = layerInfo;
        this._layer?.setOptions(this.getOptions());
        return Promise.resolve();
    }
}